import type React from 'react';

import { StarterDashboardV2BreakpointStateContext } from './context';
import { useBreakpointState } from './hook';

export const StarterDashboardV2BreakpointStateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const breakpointState = useBreakpointState();

	return (
		<StarterDashboardV2BreakpointStateContext.Provider value={breakpointState.data}>
			{children}
		</StarterDashboardV2BreakpointStateContext.Provider>
	);
};
